import { gql, MutationHookOptions, useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation reopenQuiz($id: ID!) {
    reopenQuiz(id: $id) {
      id
      closed
    }
  }
`;

export type Variables = {
  readonly id: string;
};

export type Response = {
  readonly reopenQuiz: {
    readonly id: string;
    readonly closed: string | null;
  };
};

export const useReopenQuizMutation = (
  options: MutationHookOptions<Response, Variables> = {},
) => useMutation<Response, Variables>(MUTATION, options);
